import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { Subscription } from 'rxjs';
import { SharedDataService } from 'src/services/shared-data.service';
import { Instrument } from 'src/models/question.model';
import { PlatformLocation } from '@angular/common';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.css'],
  standalone: true,
  imports: [MatButtonModule]
})


export class ThankYouComponent implements OnInit, OnDestroy {
 
routeSubscription: Subscription | undefined;
responseId: string = "";
oInstrument!: Instrument;

  constructor(private route: ActivatedRoute,
              private sharedDataService: SharedDataService,
              private platformLocation: PlatformLocation) {
                history.pushState(null, "", location.href);
                this.platformLocation.onPopState(() => {
                  history.pushState(null, "", location.href);
                });
               }
  ngOnDestroy(): void {
    this.routeSubscription != undefined ? this.routeSubscription.unsubscribe() : "";
  }

  ngOnInit(): void {
    // fetch instruments
  this.sharedDataService.instrument$.subscribe(instrument => {
    if(instrument) {
      this.oInstrument = instrument
    }
  })

  }
  
}